<swiper-container #artistSwiper init="false">
  <swiper-slide *ngFor="let artist of artists; let i = index;">
    <a [routerLink]="['artists', artist.seName]" class="image-link">
      <div class="aspect-ratio-box">
        <div class="aspect-ratio-box-inside artist-image">
          <picture>
            <source [attr.defaultImage]="settings?.holdingImage?.medium" [attr.lazyLoad]="artist.pictures[0]?.full + '.webp'" type="image/webp" />
            <img [defaultImage]="settings?.holdingImage?.medium" [lazyLoad]="artist.pictures[0]?.full" [alt]="artist.name">
          </picture>
        </div>
      </div>
    <div class="d-flex flex-row flex-wrap justify-content-end artist-info">
      <div *ngFor="let manufacturer of artist?.manufacturers" class="flex-50">
        <img [src]="manufacturer.pictureUrl" [alt]="manufacturer.name" class="artist-manufacturer">
      </div>
      <div class="flex-100">
        <div class="artist-name white-text">
          {{artist.name}}
        </div>
      </div>
    </div>
  </a>
</swiper-slide>
</swiper-container>
